import React, { Component } from 'react';
import './Riepicarrello.css';
import rplg from '../../images/public/registeration/rplg.png';
import clos from '../../images/public/registeration/clos.png';
import agdc from '../../images/public/registeration/agdc.png';
import crdscia from '../../images/public/userarea/crdscia.png';
import crdscis from '../../images/public/userarea/crdscis.png';
import crdscij from '../../images/public/userarea/crdscij.png';
import crdscib from '../../images/public/userarea/crdscib.png';
import crdpagana from '../../images/public/userarea/crdpagana.png';
import crdpaganj from '../../images/public/userarea/crdpaganj.png';
import crdpaganb from '../../images/public/userarea/crdpaganb.png';
import AlertPnl from "../../assets/components/panel/AlertPnl";
import { element } from 'prop-types';
import classNames from 'classnames';
import { BrowserView, MobileView, TabletView, isBrowser, isMobile, isTablet, isMobileOnly, isAndroid, isIOS, isFirefox, browserName } from 'react-device-detect';
import { Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle } from 'react-shapes';
import { RadioGroup, Radio } from 'react-radio-group';
import { height } from 'window-size';
import WebFont from 'webfontloader';
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import tr from '../../libs/tr'
import WaitLoad from "../../assets/components/loading/WaitLoad";
import CartProdPnl from "../../assets/components/panel/CartProdPnl";
import { checkCart, addToCart, deleteCart, getServicePrice, getTotalPriceForService, getDiscountForServices, buyService, getDiscountForApp, deleteItemInShoppingCart, addToCartByVoucher } from '../../libs/fetch'
import Cookies from 'universal-cookie';
import List from '../../assets/components/list';

const cookies = new Cookies();

class Riepicarrello extends Component {
    constructor(props) {
        super(props);

        let params = null;
        console.log('[Riepicarrello]', params);

        this.state = {
            loadedData: false,
            isLoading: false,
            errmsg: null,
            errorFlg: false,
            errorFlg2: false,
            discountPopup: false,
            discount: false, //This should be true when the customer is using discount code TODO: @Ali
            purchaseCart: null, //the data inside strPurchaseCard is parsed and converted to object array as we want and then is stored in storage
            purchaseCartIntermediate: null,//this is used for when user is removing one card from cart and we don't want to show the removed card till it received from the rest call.
            strPurchaseCard: null,//comes from checkCart to get user cart
            cardRemove: false,//Is used to show a popup for asking the user if she wants to remove the card from Cart.
            cardRemoveIndex: null,//index of card in the cart array
            oncardPrices: null,
            voucher_code: null,
            confirmedvoucher_code: null,
            totalPrice: 0,
            shipingItemExsited: false,//if there is item(s) that needs to be shipped the button texct is different than no shipment case, also, the payment will be done after user confirmed his address at next screen.

            //new rest call
            price_to_pay: 0,
            total_amount: 0,
            voucher_amount: 0,
            discountDescription: "",

            history: true,

            numberOfSkiCards: 0,
            shipmentPrices: false,//by default is false to avoid showing in the price table

        };
    }


    componentDidMount() {
        //localStorage.setItem("confirmedvoucher_code", JSON.stringify(""));//to prevent abuse when user plays with navigator...
        this.forceUpdate(() => {
            this.setState({ loadedData: true });
            this.checkCart();
        });
    }


    //This function is used to re format the received string from checkCart into purchaseCart
    createCart = () => {
        let strPurchaseCard = this.state.strPurchaseCard;
        let sepStrArr = null;
        let purchaseCart = [];
        this.setState({ isLoading: true });
        this.forceUpdate(() => {
            console.log("[Riepicarrello] createCart, @strPurchaseCard: ", this.state.strPurchaseCard);
            if (strPurchaseCard) sepStrArr = strPurchaseCard.split("_");
            console.log("[Riepicarrello] createCart, @sepStrArr: ", sepStrArr);
            if (sepStrArr && sepStrArr.length > 0) {
                for (let i = 0; i < Number(sepStrArr[0]) + Number(sepStrArr[1]); i++) {
                    purchaseCart.push({
                        number_of_services_adult: sepStrArr[0],
                        number_of_services_reduced: sepStrArr[1],
                        code: sepStrArr[2].split(",")[i],
                        provider: sepStrArr[3].split(",")[i],
                        type: sepStrArr[4].split(",")[i],
                        shipment: sepStrArr[5].split(",")[i],
                        name: sepStrArr[6].split(",")[i],
                        surname: sepStrArr[7].split(",")[i],
                        date_of_birth: sepStrArr[8].split(",")[i],
                        gender: sepStrArr[9].split(",")[i],
                        item_id: sepStrArr[10].split(",")[i],
                    });
                }
            };
            console.log("[Riepicarrello] createCart, @purchaseCart: ", purchaseCart);
            this.setState({ purchaseCart, isLoading: false, numberOfSkiCards: purchaseCart.length });
            localStorage.setItem("purchaseCart", JSON.stringify(purchaseCart));
        });
        this.getServicePrice();
    }

    gotoIndirizione = (e) => {
        e.preventDefault();
        let purchaseCart = JSON.parse(localStorage.getItem("purchaseCart"));
        console.log("[Riepicarrello] gotoIndirizione @purchaseCart", purchaseCart);
        console.log("[Riepicarrello] gotoIndirizione: should be shipped.");


        //storing pricing info to be used as payment info


        return this.props.history.push('/Indirizione');
        // this.setState({ discountPopup: true });
    }

    trybuyService = (e) => {
        e.preventDefault();
        let purchaseCart = JSON.parse(localStorage.getItem("purchaseCart"));
        console.log("[Riepicarrello] trybuyService @purchaseCart", purchaseCart);

        // this.setState({ discountPopup: true });
        this.buyService();
    }


    purchaseSuccess = (response) => {
        /*
        if the error message is something else than credit card error, 
        the purchase was successfull and user need to be noticed by post-purchase messages i.e. need for card activation, etc.
        After user confirms(pressed OK), will be redirected to the next screen.
        */
        if (response.status.indexOf('fail') != -1) {
            this.setState({
                errorFlg2: true,
                errmsg: response.message
            });
        } else return this.props.history.push('/Acquistuato');//if there is no error: 'success' case.
    }

    //this call is used to add new Card into the purchase cart
    buyService = () => {
        this.setState({ isLoading: true });
        let vc = JSON.parse(localStorage.getItem("confirmedvoucher_code"));
        let confirmedvoucher_code = vc ? vc.v_code ? vc.v_code : '' : '';
        let access_token = cookies.get('access_token');
        let params = {
            portal: 'sci',
            voucher_code: confirmedvoucher_code
        };
        buyService(this, access_token, params)
            .then((response) => {
                console.log("[Riepicarrello] buyService @response: ", response);
                if (response.status == 'fail_credit_card') {
                    //fail: user has no credit card associated, she must insert creditcard info
                    return this.props.history.push('/Insericredito');
                } else {
                    return this.purchaseSuccess(response);
                }
            });
        return
    }


    //this call is used to get price of each card
    getServicePrice = () => {
        console.log("[Riepicarrello] getServicePrice, @purchaseCart: ", this.state.purchaseCart);
        let access_token = cookies.get('access_token');
        let purchaseCart = this.state.purchaseCart;
        //check if user has any shipment
        this.setState({ shipingItemExsited: false });
        for (var x in purchaseCart) {
            if (purchaseCart[x].shipment == "1") {this.setState({ shipingItemExsited: true });this.getDeliveryPrice();break;}
        }
        let oncardPrices = [];
        for (var i in purchaseCart) {
            let params = {
                service: "sci",
                type: 'new',
                // type: purchaseCart[i].type.replace(/^\w/, c => c.toUpperCase()),//aacording to @Veronica type should be changed to :new, renew, second_card
                date_of_birth: purchaseCart[i].date_of_birth,
            }
            getServicePrice(this, access_token, params)
                .then((response) => {
                    console.log("[Riepicarrello] getServicePrice @response: ", response);
                    if (response == "fail" || response < 0) {
                        this.setState({
                            errorFlg: true,
                            errmsg: response.message
                        });
                    } else {
                        //success case!
                        oncardPrices.push(response);
                        this.setState({ oncardPrices })
                    }
                });
        }
        // let confirmedvoucher_code = localStorage.getItem("confirmedvoucher_code");
        let vc = JSON.parse(localStorage.getItem("confirmedvoucher_code"));
        let confirmedvoucher_code = vc ? vc.v_code ? vc.v_code : '' : '';

        if (!!this.state.voucher_code) {
            console.log("getServicePrice: ", 1, this.state.voucher_code);
            this.getDiscountForServices();
        } else if (confirmedvoucher_code != '') {
            console.log("getServicePrice: ", 2, confirmedvoucher_code);
            this.setState({ voucher_code: confirmedvoucher_code }, () => { this.getDiscountForServices(confirmedvoucher_code); }
            )
        } else {
            console.log("getServicePrice: ", 3);
            this.getTotalPriceForService();
        }

    }

    //this call is used to add new Card into the purchase cart
    checkCart = () => {
        let access_token = cookies.get('access_token');
        let params = {};
        checkCart(this, access_token, params)
            .then((response) => {
                console.log("[Riepicarrello] checkCart @response: ", response);
                if (response.status == "success") {
                    this.setState({ strPurchaseCard: response.cart });
                    return this.createCart();
                } else {
                    this.setState({
                        errorFlg: true,
                        errmsg: response.message
                    });
                }
            });
        return
    }

    recycle = (e) => {
        e.preventDefault();
        console.log('[Riepicarrello] @recycle');
        if (this.state.purchaseCart && this.state.purchaseCart.length < 11)
            return this.props.history.push('/welcome')
        return this.setState({
            errorFlg: true,
            errmsg: tr.t("Err_maxNumberExeeds"),
        });
    }

    CartProdPnlCB(info) {
        console.log("[Riepicarrello] CartProdPnlCB:  ", info);
        if (info.action == "remove") {
            this.setState({ cardRemoveIndex: info.index, cardRemove: true });
        }
    }

    renderCards = (that) => {
        return that.state.purchaseCart.map(function (item, index) {
            if (!!that.state.oncardPrices && !!that.state.oncardPrices[index]) {
                var formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'EUR',
                    minimumFractionDigits: 2,
                });
                console.log('renderCards', item);
                return (
                    <CartProdPnl
                        mobileViewcart={(isMobileOnly || isAndroid)}
                        key={index}
                        index={index}
                        callback={that.CartProdPnlCB.bind(that)}
                        numof={(index + 1).toString()}
                        fullName={item.name + " " + item.surname}
                        // cardType={item.provider.toLowerCase() == "axess" ? item.provider.replace(/^./, str => str.toUpperCase()) : item.provider.replace(/^./, str => str.toUpperCase()) + "(" + item.type + ")"}
                        cardType={item.type.replace(/^./, str => str.toUpperCase())}
                        price={formatter.format(that.state.oncardPrices[index])}
                        cardNumber={item.code}
                        shipped={item.shipment != "0"}
                        owned={item.code != "new"}
                        cardImage={item.provider.toLowerCase() == "axess" ? (item.type.toLowerCase() == "baby" ? crdpaganb : item.type.toLowerCase() == "junior" ? crdpaganj : crdpagana) : (item.type.toLowerCase() == "baby" ? crdscib : item.type.toLowerCase() == "junior" ? crdscij : item.type.toLowerCase() == "senior" ? crdscis : crdscia)}
                    />
                );
            }
        });
    }

    alertResponse(info) {
        console.log("Alert:", info);
        if (info.type == "closeButton") {
            this.setState({ cardRemoveIndex: null, cardRemove: false, errorFlg: false, discountPopup: false });
        }
        if (info.type == "actionButton") {
            if (info.option1 == "yes") {
                // console.log('[Riepicarrello] @alertResponse: remove confirmed!', this.state.cardRemoveIndex);
                //removiing the card from Cart...
                this.setState({
                    errorFlg: false,
                    errmsg: ''
                });

                /*let purchaseCartIntermediate = this.state.purchaseCart;
                purchaseCartIntermediate.splice(this.state.cardRemoveIndex, 1);
                console.log('[Riepicarrello] alertResponse @purchaseCartIntermediate: ', purchaseCartIntermediate);
                this.setState({ purchaseCartIntermediate });
                this.setState({ cardRemoveIndex: null, cardRemove: false });
                this.addToCart();*/

                //removing the item from cart
                let removingItem = this.state.purchaseCart[this.state.cardRemoveIndex]
                console.log('removingItem: ', removingItem);
                
                
                let access_token = cookies.get('access_token');
                deleteItemInShoppingCart(this, access_token, {item_id: removingItem.item_id})
                    .then((response) => {
                        console.log("[Riepicarrello] deleteItemInShoppingCart @response: ", response);
                        if (response.status == "success") {
                            // localStorage.setItem("purchaseCart", JSON.stringify(purchaseCart));
                             window.location.reload();
                        } else {
                            // this.setState({
                            //     errorFlg: true,
                            //     errmsg: response.message
                            // });
                            // return this.checkCart();//rerendering the screen
                           return this.props.history.push('/welcome'); //cart is empty user needs to restart the purchase
                        }
                    });
                // window.location.reload()
            }

            if (info.option2 == "no") {
                // console.log('[Riepicarrello] @alertResponse: remove Not confirmed!');
                this.setState({ cardRemoveIndex: null, cardRemove: false });
            }
            if (info.option1 == "attention") {
                this.setState({ errorFlg: false })
            }
            if (info.option1 == "errorPurchase") {
                this.setState({ errorFlg2: false })
                return this.props.history.push('/Acquistuato');
            }

            if (info.option1 == "usedis") {
                this.setState({ discountPopup: false });
            }
            if (info.option2 == "skip") {
                this.setState({ discountPopup: false })
            }
        }
        if (info.type == "apply") {
            this.setState({ voucher_code: info.vcode }, () => {
                this.getDiscountForServices();
            })

        }
        if (info.type == "purchase") {
            this.setState({ discountPopup: false })
            if (!this.state.shipingItemExsited)
                this.buyService();
            else
                return this.props.history.push('/Indirizione');
        }
    }

    /*
    //this call is used to add new Card into the purchase cart
    //Here, this function is applied when user is removing a card, so the number_of_services_adult should decreased by 1.
    addToCart = () => {
        this.forceUpdate(() => {
            let purchaseCart = this.state.purchaseCartIntermediate;
            console.log('[Riepicarrello] addToCart @purchaseCart: ', purchaseCart);
            let params = {};
            let joint_number_of_services_adult = "";
            let joint_number_of_services_reduced = "";
            let joint_code = "";
            let joint_type = "";
            let joint_provider = "";
            let joint_shipment = "";
            let joint_name = "";
            let joint_surname = "";
            let joint_date_of_birth = "";
            let joint_gender = "";
            //concatenating same parameters 
            for (var i in purchaseCart) {
                // joint_number_of_services_adult += (i > 0 ? "," : "") + purchaseCart[i].number_of_services_adult;
                // joint_number_of_services_reduced += (i > 0 ? "," : "") + purchaseCart[i].number_of_services_reduced;
                joint_number_of_services_adult = (Number(purchaseCart[i].number_of_services_adult) - 1).toString();//we need only the latest number
                joint_number_of_services_reduced = purchaseCart[i].number_of_services_reduced;//we need only the latest number
                joint_code += (i > 0 ? "," : "") + purchaseCart[i].code;
                joint_type += (i > 0 ? "," : "") + purchaseCart[i].type;
                joint_provider += (i > 0 ? "," : "") + purchaseCart[i].provider;
                joint_shipment += (i > 0 ? "," : "") + purchaseCart[i].shipment;
                joint_name += (i > 0 ? "," : "") + purchaseCart[i].name;
                joint_surname += (i > 0 ? "," : "") + purchaseCart[i].surname;
                joint_date_of_birth += (i > 0 ? "," : "") + purchaseCart[i].date_of_birth;
                joint_gender += (i > 0 ? "," : "") + purchaseCart[i].gender;
            }
            params = {
                number_of_services_adult: joint_number_of_services_adult,
                number_of_services_reduced: joint_number_of_services_reduced,
                code: joint_code,
                type: joint_type,
                provider: joint_provider,
                shipment: joint_shipment,
                name: joint_name,
                surname: joint_surname,
                date_of_birth: joint_date_of_birth,
                gender: joint_gender,
            }
            if (purchaseCart.length == 0) {
                params = {};
                //last card cannot be deleted by addToCart. We need to use deleteCart
                let access_token = cookies.get('access_token');
                deleteCart(this, access_token, params)
                    .then((response) => {
                        console.log("[Riepicarrello] deleteCart @response: ", response);
                        if (response.status == "success") {
                            localStorage.setItem("purchaseCart", JSON.stringify(purchaseCart));
                            return this.props.history.push('/welcome'); //cart is empty user needs to restart the purchase
                        } else {
                            this.setState({
                                errorFlg: true,
                                errmsg: response.message
                            });
                            return this.checkCart();//rerendering the screen
                        }
                    });
            } else {
                console.log('[Riepicarrello] addToCart @purchaseCart: ', purchaseCart);
                console.log('[Riepicarrello] addToCart @params: ', params);
                let access_token = cookies.get('access_token');
                addToCart(this, access_token, params)
                    .then((response) => {
                        console.log("[Riepicarrello] addToCart @response: ", response);
                        if (response.status == "success") {
                            return this.checkCart();//rerendering the screen
                        } else {
                            this.setState({
                                errorFlg: true,
                                errmsg: response.message
                            });
                            return this.checkCart();//rerendering the screen
                        }
                    });
                return
            }

        })
    }*/


    //this call is used to get the totall price of services
    getTotalPriceForService = () => {
        this.setState({ discount: false });
        this.forceUpdate(() => {
            let access_token = cookies.get('access_token');
            let params = {
                number_of_services_adult: this.state.strPurchaseCard.split("_")[0],
                number_of_services_reduced: this.state.strPurchaseCard.split("_")[1],
            }
            getTotalPriceForService(this, access_token, params)
                .then((response) => {
                    console.log("[Riepicarrello] getTotalPriceForService @response: ", response);
                    if (response.status != "fail") {
                        this.setState({ totalPrice: response });
                        localStorage.setItem("totalPrice", JSON.stringify(response));
                    } else {
                        this.setState({
                            errorFlg: true,
                            errmsg: response.message
                        });
                    }
                });
            return
        })
    }

    //this call is used to get the discount for services
    getDiscountForServices = () => {
        this.setState({
            errorFlg: false,
            errmsg: ""
        });
        this.forceUpdate(() => {
            let vc = JSON.parse(localStorage.getItem("confirmedvoucher_code"));
            let confirmedvoucher_code = vc ? vc.v_code ? vc.v_code : '' : '';

            let v_code = this.state.history ? confirmedvoucher_code : this.state.voucher_code;
            console.log("[Riepicarrello] params:0 ", this.state.history, vc);

            let access_token = cookies.get('access_token');
            let params = {
                voucher_code: v_code,
                number_of_services_adult: this.state.strPurchaseCard.split("_")[0],
                number_of_services_reduced: this.state.strPurchaseCard.split("_")[1],
            }

            console.log("[Riepicarrello] params:1 ", params);

            getDiscountForApp(this, access_token, params)
                .then((response) => {
                    console.log("[Riepicarrello] getDiscountForApp @response: ", response);
                    if (response.status == "success") {
                        // this.setState({ totalPrice: response, confirmedvoucher_code: this.state.voucher_code });
                        localStorage.setItem("totalPrice", JSON.stringify(response.price_to_pay));
                        localStorage.setItem("confirmedvoucher_code", JSON.stringify({ v_code: v_code }));

                        this.setState({
                            confirmedvoucher_code: v_code,
                            price_to_pay: response.price_to_pay,
                            total_amount: response.total_amount,
                            voucher_amount: response.voucher_amount,
                            discountDescription: response.discount,
                            history: true,
                            discount: true,
                        });

                        //re-calling addToCart to notify the discount
                        let access_token = cookies.get('access_token');
                        let addToCartByVoucherParams = {
                            item_type: "voucher",
                            item_desc:v_code,
                        }
                        addToCartByVoucher(this, access_token, addToCartByVoucherParams)
                            .then((response) => {
                                console.log("[Configminore] addToCartByVoucher @response: ", response);
                                if (response.status == "success") {
                                    //what to do?
                                } else {
                                    this.setState({
                                        errorFlg: true,
                                        errmsg: response.message
                                    });
                                }
                            });                        
                        
                    } else {
                        localStorage.setItem("totalPrice", null);
                        localStorage.setItem("confirmedvoucher_code", null);
                        this.setState({
                            confirmedvoucher_code: null,
                            errorFlg: true,
                            errmsg: response.message
                        });
                        this.getTotalPriceForService();//in case of error or invalidity of the promo code, the total price is loaded
                    }
                });
            return
        })
    }


    // //this call is used to get the discount for services
    // getDiscountForApp = () => {
    //     this.setState({
    //         errorFlg: false,
    //         errmsg: ""
    //     });
    //     this.forceUpdate(() => {
    //         let access_token = cookies.get('access_token');
    //         let params = {
    //             voucher_code: this.state.voucher_code,
    //             number_of_services_adult: this.state.strPurchaseCard.split("_")[0],
    //             number_of_services_reduced: this.state.strPurchaseCard.split("_")[1],
    //         }
    //         getDiscountForApp(this, access_token, params)
    //             .then((response) => {
    //                 console.log("[Riepicarrello] getDiscountForApp @response: ", response);
    //                 // if (response.status != "fail") {
    //                 //     // this.setState({ totalPrice: response, confirmedvoucher_code: this.state.voucher_code });
    //                 //     // localStorage.setItem("totalPrice", JSON.stringify(response));
    //                 //     // localStorage.setItem("confirmedvoucher_code", JSON.stringify(this.state.voucher_code));
    //                 // } else {
    //                 //     this.setState({
    //                 //         errorFlg: true,
    //                 //         errmsg: response.message
    //                 //     });
    //                 // }
    //             });
    //         return
    //     })
    // }


    handleChange_voucher_code = (e) => {
        e.preventDefault();
        let voucher_code = e.target.value
        console.log('[Riepicarrello] handleChange_voucher_code @voucher_code: ', voucher_code);
        this.setState({ voucher_code });
        return
    }

    //get delivery price to show as notice 
    getDeliveryPrice = () => {
        let access_token = cookies.get('access_token');
        let params = {
            service: "sci",
            portal: 'sci',//neede for getServiceDescription
            type: 'shipment'
        };

        getServicePrice(this, access_token, params)
            .then((response) => {
                console.log("[Riepicarrello] getServicePrice @response: ", response);
                if (response == "fail" || response < 0) {
                    console.log("[Riepicarrello] getServicePrice error");
                    this.setState({
                        errorFlg: true,
                        errmsg: response.message
                    });
                } else {
                    //success case!
                    console.log("[Riepicarrello] getServicePrice success", response);
                    this.setState({ shipmentPrices: response })
                }
            });
    }


    calculateTotalServicePrice=()=>{
        // console.log('calculateTotalServicePrice:', 'total_amount: ', this.state.totalPrice, 'total_amount: ', this.state.total_amount); 
       return  this.state.totalPrice? this.state.totalPrice :this.state.total_amount;
    }



    onBtnPressed = (e) => {
        e.preventDefault();
        let totPrice = this.calculateTotalServicePrice()
        let shipmentPrice = this.state.shipmentPrices ? this.state.shipmentPrices : false;
        let discountPrice = this.state.voucher_amount ? -1 * this.state.voucher_amount : false;
        let priceToPay = totPrice + (shipmentPrice ? shipmentPrice : 0) + (discountPrice ? discountPrice : 0);

        let price_info = {
            info:
                [[`N° ${this.state.numberOfSkiCards} card`, totPrice],
                [tr.t('shippingCost'), shipmentPrice],
                    [tr.t('discount') + (this.state.discountDescription ? ` (-${this.state.discountDescription})` : ""), discountPrice]],
            priceToPay: priceToPay
        }

        localStorage.setItem("price_info", JSON.stringify(price_info));
        console.log('onBtnPressed', price_info);
        console.log('onBtnPressed', e.target.id);

        if (e.target.id == 'btnnext') return this.gotoIndirizione(e);
        return this.trybuyService(e);

    }

    render() {
        console.log('[Riepicarrello]', this.state);
        var formatter = new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
        });
        return (
            <Router>
                <div>
                    <div>
                        <BrowserView>
                            <div className="containermbcgrcb">
                                {tr.userlng() == 'IT' && <div className="navrcbi"></div>}
                                {tr.userlng() != 'IT' && <div className="navrcbe"></div>}
                                <div className="containermrcb">
                                    <div className="closrcb">
                                        <a onClick={() => { return this.props.history.push('/') }}><img src={clos} className="rspn" /></a>
                                    </div>
                                    <div className="rplgrcb">
                                        {tr.t("Summary")}
                                    </div>
                                    <div className="containerCart">
                                        {this.state.purchaseCart && this.renderCards(this)}
                                    </div>
                                    <div className="containerisrcb">
                                        <div className="containerisircb">
                                            <input type="text" name="name" placeholder={tr.t("Discountcode")} className="txlrcb1" maxLength="50" value={this.state.code} onChange={this.handleChange_voucher_code} />
                                        </div>
                                        <button className="isbtn" onClick={() => { this.setState({ history: false }, () => { this.getDiscountForServices() }) }}>{tr.t("Apply")}</button>
                                    </div>
                                    <div className="containerlist">
                                       {this.calculateTotalServicePrice()>0&& <List elements={[
                                            [`N° ${this.state.numberOfSkiCards} card`, this.calculateTotalServicePrice()],
                                            [tr.t('shippingCost'), this.state.shipmentPrices],
                                            [tr.t('discount') + (this.state.discountDescription ? ` (-${this.state.discountDescription})` : ""), this.state.voucher_amount ? -1 * this.state.voucher_amount : false],
                                        ]} />  }                                   
                                    </div>
                                    {/*
                                    {!this.state.discount &&
                                        <div>
                                            <div className="containerlrcb"></div>
                                            <div className="containertprcb">
                                                {tr.t("Total")}
                                                <div className="totalPart">
                                                    <strong className="txlrcb2">{formatter.format(this.state.totalPrice)}</strong>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {this.state.discount &&
                                        <div>
                                            <div className="containertprcbd1">
                                                {tr.t("Total")}
                                                <div className="totalPart">
                                                    <strong className="txlrcb2">{formatter.format(this.state.total_amount)}</strong>
                                                </div>
                                            </div>
                                            <div className="containertprcbd2">
                                                {this.state.confirmedvoucher_code}
                                                <div className="totalPart">
                                                    <strong className="txlrcb2">-&#160;{formatter.format(this.state.voucher_amount)}</strong>
                                                </div>
                                            </div>
                                            <div className="containerlrcbd"></div>
                                            <div className="containertprcbd3">
                                                {tr.t("Finalprice")}
                                                <div className="totalPart">
                                                    <strong className="txlrcb2">{formatter.format(this.state.price_to_pay)}</strong>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    */}
                                    {/* {this.state.errorFlg && <div className="warnrc">{this.state.errmsg}</div>} */}
                                    <div className="containerbrcb">
                                        <form>
                                            <button className="nbtnrc" onClick={this.recycle}>{tr.t("Addnew")}</button>
                                        </form>
                                        <form>
                                            {this.state.shipingItemExsited && <button id="btnnext" className="lbtnrc" onClick={(e)=>{this.onBtnPressed(e)}}>{tr.t("Next")}</button>}
                                            {!this.state.shipingItemExsited && <button id="btnpay" className="lbtnrc" onClick={(e)=>{this.onBtnPressed(e)}}>{tr.t("Purchase")}</button>}
                                        </form>
                                    </div>
                                    <div className="marginBottomrc"></div>
                                </div>
                            </div>
                        </BrowserView>
                        <MobileView>
                            <div className="containermbcgrcm">
                                <div className="navrcm"></div>
                                <div className="containermrcm">
                                    <div className="closrcm">
                                        <a onClick={() => { return this.props.history.push('/') }}><img src={clos} className="rspn" /></a>
                                    </div>
                                    <div className="rplgrcm">
                                        {tr.t("Summary")}
                                    </div>
                                    <div className="containerCartm">
                                        {this.state.purchaseCart && this.renderCards(this)}
                                    </div>
                                    <div className="containerisrcm">
                                        <div className="containerisircm">
                                            <input type="text" name="name" placeholder={tr.t("Discountcode")} className="txlrcm1" maxLength="50" value={this.state.code} onChange={this.handleChange_voucher_code} />
                                        </div>
                                        <button className="isbtnm" onClick={() => { this.setState({ history: false }, () => { this.getDiscountForServices() }) }}>{tr.t("Apply")}</button>
                                    </div>
                                    <div className="containerlistmobile">
                                    <List elements={[
                                            [`N° ${this.state.numberOfSkiCards} card`, this.state.total_amount],
                                            [tr.t('shippingCost'), this.state.shipmentPrices],
                                            [tr.t('discount') + (this.state.discountDescription ? ` (-${this.state.discountDescription})` : ""), this.state.voucher_amount ? -1 * this.state.voucher_amount : false],
                                        ]} />                                     
                                    </div>
                                    {/*
                                    {!this.state.discount &&
                                        <div>
                                            <div className="containerlrcm"></div>
                                            <div className="containertprcm">
                                                {tr.t("Total")}
                                                <div className="totalPartm">
                                                    <strong className="txlrcm2">{formatter.format(this.state.totalPrice)}</strong>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {this.state.discount &&
                                        <div>
                                            <div className="containertprcmd1">
                                                {tr.t("Total")}
                                                <div className="totalPartm">
                                                    <strong className="txlrcm2">{formatter.format(this.state.total_amount)}</strong>
                                                </div>
                                            </div>
                                            <div className="containertprcmd2">
                                                {this.state.voucher_code}
                                                <div className="totalPartm">
                                                    <strong className="txlrcm2">-&#160;{formatter.format(this.state.voucher_amount)}</strong>
                                                </div>
                                            </div>
                                            <div className="containerlrcmd"></div>
                                            <div className="containertprcmd3">
                                                {tr.t("Finalprice")}
                                                <div className="totalPartm">
                                                    <strong className="txlrcm2">{formatter.format(this.state.price_to_pay)}</strong>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    */}
                                    {/* {this.state.errorFlg && <div className="warnrcm">{this.state.errmsg}</div>} */}
                                    <div className="containerbrcm">
                                        <form>
                                            <button className="nbtnrcm" onClick={this.recycle}>{tr.t("Addnew")}</button>
                                        </form>
                                        <form>
                                            {this.state.shipingItemExsited && <button id="btnnext" className="lbtnrcm" onClick={(e)=>{this.onBtnPressed(e)}}>{tr.t("Next")}</button>}
                                            {!this.state.shipingItemExsited && <button id="btnpay" className="lbtnrcm" onClick={(e)=>{this.onBtnPressed(e)}}>{tr.t("Purchase")}</button>}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </MobileView>
                    </div>
                    {this.state.cardRemove ?
                        <div className="containerModal">
                            {this.state.cardRemove ?
                                <AlertPnl textbar1={tr.t("RemoveCard")} doublebtnhor={true} textbtn1={tr.t("Yes")} textbtn2={tr.t("No")} option1={"yes"} option2={"no"} callback={this.alertResponse.bind(this)} /> : null
                            }
                        </div> : null
                    }
                    {this.state.errorFlg ?
                        <div className="containerModal">
                            {this.state.errorFlg ?
                                <AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.errmsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
                            }
                        </div> : null
                    }
                    {!this.state.errorFlg && this.state.discountPopup ?
                        <div className="containerModal">
                            {this.state.discountPopup ?
                                <AlertPnl discount={true} totalPrice={formatter.format(this.state.totalPrice)} secondbar={true} textbar1={tr.t("Discountcode")} textbar2={tr.t("Insertdiscount")} doublebtnver={true} textbtn1={tr.t("Purchasediscount")} textbtn2={tr.t("Skipurchase")} option1={"usedis"} option2={"skip"} callback={this.alertResponse.bind(this)} /> : null
                            }
                        </div> : null
                    }
                    {this.state.errorFlg2 ?
                        <div className="containerModal">
                            {this.state.errorFlg2 ?
                                <AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.errmsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"errorPurchase"} closehide={true} callback={this.alertResponse.bind(this)} /> : null
                            }
                        </div> : null
                    }                      
                    <WaitLoad enable={this.state.isLoading} />
                </div >
            </Router >
        );
    }
}

export default Riepicarrello;


// WEBPACK FOOTER //
// ./src/screens/Riepicarrello/Riepicarrello.js